import { useContext } from "react";
import Filters from "./filters";
import Table from "./table";
import { Drawer } from "@MASTER";
import useTabs from "./tab-content";
import { DrawerContext } from "@CONTEXTS";
import { Tag } from "antd";

const Operation = () => {
  const TabContent = useTabs();
  const { data } = useContext(DrawerContext);

  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters />
        </div>
      </div>
      <div className="nav-page-content">
        <div className="app-deliveries">
          <Table />
        </div>
      </div>
      <Drawer
        tabs={TabContent}
        hideFooter
        tabBarExtraContent={{
          right: data && (
            <Tag color="blue">{data?.delivery?.deliveryStatusText}</Tag>
          ),
        }}
      />
    </>
  );
};

export default Operation;
